import { render, staticRenderFns } from "./SubmitUploadModal.vue?vue&type=template&id=c658c0a6&scoped=true&"
import script from "./SubmitUploadModal.vue?vue&type=script&lang=js&"
export * from "./SubmitUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmitUploadModal.vue?vue&type=style&index=0&id=c658c0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c658c0a6",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormFile, BModal} from 'bootstrap-vue'
    installComponents(component, {BFormFile, BModal})
    

export default component.exports